import React from 'react';
import { useParams } from 'react-router-dom';
import Listing from '../components/Listing.js';
import { changeBrowserTitle } from '../hooks/headAmender.js';
import locationBadgeIcon from '../helpers/locationBadgeIcon.js';

const SearchPage = () => {
    const { match } = useParams();
    changeBrowserTitle(`Search ${match ?? "all"}`);

    return (
        <section>
            <h1 style={{ display: "none" }}>Search results</h1>
            <Listing
                heading={`Search results for ${match ?? "all"}`}
                search={match ?? ""}
                sort="date"
                order="desc"
                initialCount={6}
                paginateBy={6}
                badgeKeys={[
                    { key: "los", icon: "people" },
                    { key: "location", icon: locationBadgeIcon }
                ]}
            />
        </section>
    );
};

export default SearchPage;
